/* eslint-disable */
import request from '@/request/index'

/**
 *  快手电商H5页-用户登录
 * @param {*} order_no
 * @param type
 * @returns null
 */
export function login(data) {
  return request({
    url: '/kuaishou/login-e-commerce',
    method: 'post',
    isToast: true,
    data
  })
}
/**
 *  新增紧急联系人
 * @param {*} data
 * @returns null
 */
export function emergencyContacts(data) {
  return request({
    url: '/api/users/emergency-contacts',
    method: 'post',
    tokenKey: 'ksH5token',
    isToast: true,
    data,
  })
}
/**
 *  实名认证
 * @param {*} data
 * @returns null
 */
export function realNameAuthentication(data) {
  return request({
    url: '/api/users/id-card-number',
    method: 'post',
    tokenKey: 'ksH5token',
    isToast: true,
    data,
  })
}
/**
 *  人脸认证
 * @returns null
 */
export function faceAuthentication(data) {
  return request({
    url: '/api/users/esign-face-auth',
    tokenKey: 'ksH5token',
    isToast: true,
    method: 'post',
    data
  })
}
/**
 *  查询人脸认证结果
 * @returns null
 */
export function faceAuthenticationResult() {
  return request({
    url: '/api/users/esign-face-auth-result',
    tokenKey: 'ksH5token',
    method: 'get'
  })
}
/**
 *  用户注册进度查询
 * @returns null
 */
export function registrationProgress() {
  return request({
    url: '/kuaishou/e-commerce-user-progress',
    tokenKey: 'ksH5token',
    isToast: true,
    method: 'get'
  })
}

/**
 *  smsCode
 * @param {*} data
 * @returns null
 */
export function smsCode(data) {
  return request({
    url: '/api/users/login/send-sms',
    method: 'post',
    isToast: true,
    data,
  })
}

/**
 * 上传
 * @param { Object } data FormData格式数据
 * @param {string} data.file
 * @param {string} data.path
 * @returns null
 */
export function upload(data) {
  return request({
    url: '/api/upload/mini-app-images',
    // url: '/api/upload/images',
    method: 'post',
    tokenKey: 'ksH5token',
    isToast: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data,
  })
}
